import { render, staticRenderFns } from "./LegoViewInModalColaboradores.vue?vue&type=template&id=8da4c7ce&scoped=true"
import script from "./LegoViewInModalColaboradores.vue?vue&type=script&lang=js"
export * from "./LegoViewInModalColaboradores.vue?vue&type=script&lang=js"
import style0 from "./LegoViewInModalColaboradores.vue?vue&type=style&index=0&id=8da4c7ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da4c7ce",
  null
  
)

export default component.exports